import React from "react";
import { EnumUpdatePriceType } from "../../../../../server/routes/logUpdated/price/types";
import SelectField from "../../../components/SelectField";
import useFilterValue from "../Provider/hooks/useFilterValue";
import { FieldHaveErrorFC } from "./types";

export const TypeToName: { [name in EnumUpdatePriceType]: string } = {
  [EnumUpdatePriceType.PRICES]: "Обновление цен",
  [EnumUpdatePriceType.DISCOUNT]: "Обновление скидок",
};

const FieldType: FieldHaveErrorFC = () => {
  const { value, update } = useFilterValue("type");
  const handlerChange = (type: string) => {
    switch (type) {
      case EnumUpdatePriceType.DISCOUNT:
      case EnumUpdatePriceType.PRICES:
        update(type);
        break;
      default:
        update(undefined);
        break;
    }
  };
  return (
    <SelectField
      size={"small"}
      onChange={handlerChange}
      items={[
        {
          label: TypeToName[EnumUpdatePriceType.PRICES],
          value: EnumUpdatePriceType.PRICES,
        },
        {
          label: TypeToName[EnumUpdatePriceType.DISCOUNT],
          value: EnumUpdatePriceType.DISCOUNT,
        },
      ]}
      value={value}
      label={"Тип лога"}
    />
  );
};

export default FieldType;
